import { Dialog, Button, Box, Text } from '@machobear/design-system'
import { useTranslation } from 'react-i18next'
import CautionIcon from './caution-icon.svg'

type Props = {
  visible: boolean
  title?: string
  onClose: () => void
  width?: 'small' | 'content' | 'xsmall' | 'medium' | 'large' | 'xlarge' | undefined
  cancelCreditCheck?: () => void
}

const CancelSubmitModal = ({ width, visible, title, onClose, cancelCreditCheck }: Props) => {
  const { t } = useTranslation()

  return (
    <Dialog id="credit-check-modal" open={visible} onClose={onClose} width={width} title="">
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <img width={'57px'} src={CautionIcon} alt="caution" style={{ paddingBottom: '24px' }} />
        <>
          <Box style={{ paddingBottom: '16px' }}>
            <Text size="large" weight="strong">
              {t('r.profile.edit_go_back_modal_title', 'Are you sure?')}
            </Text>
          </Box>
          <Box style={{ paddingBottom: '32px' }}>
            <Text size="standard" weight="regular" align="center">
              {t(
                'r.profile.edit_cancel_cedit_check_text1',
                'By cancelling your credit check, your application will indicate that you have no credit history in Canada.'
              )}
            </Text>
          </Box>
          <Box style={{ paddingBottom: '32px' }}>
            <Text size="standard" weight="regular" align="center">
              {t(
                'r.profile.eidt_cancel_credit_check_text2',
                'Note: You can edit this at a later time.'
              )}
            </Text>
          </Box>
          <Box display="flex" alignItems="center" gap="xsmall" style={{ width: '100%' }}>
            <Button variant="transparent" size="small" onClick={onClose}>
              {t('common.cancel', 'Cancel')}
            </Button>
            <Button variant="solid" onClick={cancelCreditCheck}>
              {t('common.continue', 'Continue')}
            </Button>
          </Box>
        </>
      </Box>
    </Dialog>
  )
}

export default CancelSubmitModal
